import React from 'react';
//material
import {withStyles, Card, CardActionArea, CardMedia, CardContent} from '@material-ui/core';
import {Skeleton} from '@material-ui/lab';
//styles
import styles from './group-item-styles';
import Moment from 'moment';

const GroupItemView = (props) => {
  const {classes, isLoading, group, navigate} = props;

  return (
    <Card>
      <CardActionArea disableRipple={isLoading} onClick={!isLoading ? () => navigate(group.organisationGroupId) : null}>
        {
          isLoading ?
            <Skeleton variant={'rect'} height={165} /> :
            <CardMedia
              title={'Group Image'}
              image={group.imageUrl}
              className={classes.img}
            />
        }

        <CardContent className={classes.cardContent}>
          {
            isLoading ?
              <Skeleton height={24}/> :
              <div className={classes.name}>
                {group.name}
              </div>
          }

          {
            isLoading ?
              <Skeleton height={12} width={'40%'} /> :
              <div className={classes.subtitle}>
                {group.clubName}
              </div>
          }

          {
            isLoading ?
              <Skeleton height={12} width={'40%'} /> :
              <div className={classes.subtitle}>
                {group.nextMeetingDate ? 'Next Meeting: ' + Moment(new Date(group.nextMeetingDate)).format('ddd Do MMMM YYYY') : ''}
              </div>
          }

          {
            isLoading ?
              <Skeleton height={12} width={'40%'} className={classes.skeletonMembers} /> :
              <div className={classes.members}>
                Members:&nbsp;{group.memberCount}
              </div>
          }

        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default withStyles(styles) (GroupItemView);
